import { useState, useEffect } from "react";
import "./style.css";
import api from "../../../services/api.js";
import { useAppContext } from '../../../context/AppContext.js';
import LoadingScreen from "../../../componente/aguarde";
import Impressora from "../../../assets/Impressora.png";
import ImgXLS from "../../../assets/XLS.png";
import * as XLSX from 'xlsx';

function RelHumor() {
    const { DateTime } = require("luxon");
    const [lista, setlista] = useState([]);
    const [abusca, setabusca] = useState("");
    const [loading, setLoading] = useState(false);

    const dt = new Date();

    const date1 =
        dt.getFullYear() +
        "-" +
        (dt.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        dt.getDate().toString().padStart(2, "0");

    const date2 =
        dt.getFullYear() +
        "-" +
        (dt.getMonth() + 1).toString().padStart(2, "0") +
        "-" +
        dt.getDate().toString().padStart(2, "0");

    const [dt1, setdt1] = useState(date1);
    const [dt2, setdt2] = useState(date2);

    const { selectedCompany, accessKey } = useAppContext(); 

    function ListarHumor() {
        api
            .get("/v1/relatorio/humor", {
                params: {
                    busca: abusca,
                    codempresa: selectedCompany,
                    dt1,
                    dt2,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            })
            .then(function (response) {
                setlista(response.data);
            })
            .catch(function (err) {
                console.log("ops! ocorreu um erro: " + err);
            });
    }

    useEffect(
        function () {
            ListarHumor();
        },
        [abusca, selectedCompany, dt1, dt2]
    );

    const imprimir = async () => {
        setLoading(true);

        try {
            const response = await api.get(`/v1/impressoes/relatorio/humor`, {
                responseType: "arraybuffer",
                params: {
                    busca: abusca,
                    codempresa: selectedCompany,
                    dt1,
                    dt2,
                },
                headers: {
                    Authorization: `Bearer ${accessKey}`,
                },
            });

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.target = "_blank";
            link.click();
        } catch (error) {
            console.log("ops! ocorreu um erro: " + error);
        } finally {
            setLoading(false);
        }
    };

    function FormataDataHora(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy HH:mm:ss")
            : null;
    }

    function FormataData(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 3 })
                .toFormat("dd/MM/yyyy")
            : null;
    }

    function FormataHora(props) {
        return props
            ? DateTime.fromISO(props)
                .plus({ hours: 0 })
                .toFormat("HH:mm:ss")
            : null;
    }

    const exportToExcel = () => {
        // Cria uma nova planilha a partir dos dados da tabela
        const worksheet = XLSX.utils.json_to_sheet(lista);

        // Cria uma nova pasta de trabalho e adiciona a planilha
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

        // Exporta o arquivo Excel com o nome especificado
        XLSX.writeFile(workbook, `relhumor.xlsx`);
    };

    return (
        <>
            <div className="app-container">
                <div className="container-fluid">
                    <div className="row">
                        <h1 className="ms-4">Relatório do Humor</h1>
                        <p className="ms-4">Relatório do humor que foi registrado pelos profissionais</p>
                        <hr />
                    </div>

                    <div className="row">
                        <div className="col-4">
                            <label className="form-label" htmlFor="busca">
                                Busque aqui
                            </label>
                            <input
                                type="text"
                                placeholder="Buscar por: Nome do profissional"
                                name="busca"
                                id="busca"
                                className="form-control me-3"
                                value={abusca}
                                onChange={(e) => setabusca(e.target.value)}
                            />
                        </div>

                        <div className="col-sm-3">
                            <label htmlFor="dtlancamento" className="form-label">
                                Lançamento de
                            </label>
                            <input
                                type="date"
                                id="dtlancamento"
                                className="form-control"
                                placeholder="Dt. Lançamento"
                                value={dt1}
                                onChange={(e) => setdt1(e.target.value)}
                            />
                        </div>

                        <div className="col-sm-3">
                            <label htmlFor="dtlancamento" className="form-label">
                                Para...
                            </label>
                            <input
                                type="date"
                                id="dtlancamento"
                                className="form-control"
                                placeholder="Dt. Lançamento"
                                value={dt2}
                                onChange={(e) => setdt2(e.target.value)}
                            />
                        </div>

                        <div className="col-sm-1 d-flex justify-content-center">
                            <button className="btn" onClick={exportToExcel}>
                                <img src={ImgXLS} alt="XLS" />
                                <label>Excel</label>
                            </button>
                            {loading && <LoadingScreen />}
                        </div>

                        <div className="col-sm-1 d-flex justify-content-center">
                            <button className="btn" onClick={imprimir}>
                                <img src={Impressora} alt="Imprimir" />
                                <label>Imprimir</label>
                            </button>
                            {loading && <LoadingScreen />}
                        </div>
                    </div>

                    <div className="row mt-3">
                        <hr />
                    </div>

                    <div className="row">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Dt. Lançamento</th>
                                    <th>Hr. Lançamento</th>
                                    <th>Momento</th>
                                    <th>Nome</th>
                                    <th>Tipo de Humor</th>
                                </tr>
                            </thead>
                            <tbody>
                                {lista.map(function (item) {
                                    return (
                                        <tr key={item.codhumor}>
                                            <th>{FormataData(item.dtlancamento)}</th>
                                            <th>{FormataHora(item.hrlancamento)}</th>
                                            <th>{item.momento}</th>
                                            <th>{item.nome}</th>
                                            <th>{item.tipohumor}</th>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colSpan={4}>Quantidade de Registros: {lista.length}</th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default RelHumor;
